module.exports = __webpack_public_path__ + "assets/4eb9f8be081619c11b2a6ebbd24bf6d0.mp3";


/*****************
 ** WEBPACK FOOTER
 ** ./public-src/sounds/buttons/denoms/denom-12.mp3
 ** module id = 469
 ** module chunks = 0
 **/